import { render, staticRenderFns } from "./ResidentSignUp.vue?vue&type=template&id=6f39a589&scoped=true&"
import script from "./ResidentSignUp.vue?vue&type=script&lang=ts&"
export * from "./ResidentSignUp.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentSignUp.vue?vue&type=style&index=0&id=6f39a589&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39a589",
  null
  
)

export default component.exports